import React, {Component} from 'react';
import {Problem} from './Problem';
import {getSubject} from "../services/SubjectService";
import {LearnPage} from "./LearnPage";
import {LearnBox} from "./LearnBox";
import {LearnSection} from "./LearnSection";

export class Practice extends Component {
    static displayName = Practice.name;

    constructor(props) {
        super(props);
        const pathParts = window.location.pathname.split("/");
        const subjectKey = pathParts[2];
        const themeKey = pathParts[3];
        this.state = {subjectKey: subjectKey, themeKey: themeKey, loading: true};
    }

    componentDidMount() {
        this.fetchSubject()
    }

    render() {
        if (this.state.loading) return <div>Indlæser opgave...</div>;

        return (
            <LearnPage title={this.state.title} backUrl={"/subject/" + this.state.subjectKey}
                       backTitle={this.state.subject.displayName}>
                <LearnSection>
                    <LearnBox>
                        <Problem subjectKey={this.state.subjectKey} themeKey={this.state.themeKey}/>
                    </LearnBox>
                </LearnSection>
            </LearnPage>
        );
    }

    fetchSubject() {
        getSubject(this.state.subjectKey).then(subject => {
            const theme = subject.themes.filter(t => t.key === this.state.themeKey)[0];
            const title = theme ? theme.displayName : subject.displayName;
            this.setState({subject: subject, title: title, loading: false});
        });
    }
}
